import { create } from 'zustand';

const useUserStore = create((set) => ({
  windowInnerWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
  showMessageObj: {
    open: false,
    message: '',
    status: '',
  },

  // actions
  setWindowInnerWidth: (width) => set({ windowInnerWidth: width }),
  setShowMessageObj: (obj) => set({ showMessageObj: obj }),
}));

export default useUserStore;
